import React, { useState, useEffect } from 'react'
import DataTable from '../Shared/DataTable/DataTable.js'
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import Error from '../Shared/Error.js'
import ItemDetailsPane from './ItemDetailsPane.js'
import AddItemPopup from './AddItemPopup.js'
import LoadingSpinnerImage from '../Shared/LoadingSpinnerImage.js'

const RegulatoryDocuments = () => {

    const [isLoadingStructure, setIsLoadingStructure] = useState(true);
    const [errorLoadingStructure, setErrorLoadingStructure] = useState(false);
    const [dataTableStructure, setDataTableStructure] = useState({});

    let config = {};

    config.dataUrl = "/umbraco/api/Compliance/RegulatoryDocuments";
    config.getSingleItemUrl = "/umbraco/api/Compliance/RegulatoryDocument";
    config.pageTitle = "Regulations";
    config.singleItemTitle = "Regulation";
    config.entityType = "compliance-regulatorydocuments";
    config.entityTypeId = 3; // compliance-regulatorydocuments
    config.pageIcon = "fas fa-landmark";
    config.breadcrumbs = [{ "Name": "Compliance Manager", "Link": "/your-medboard/compliance-portfolio/" }, { "Name": "Regulations", "Link": "/your-medboard/compliance-portfolio/regulatory-documents/" }]
    config.dataStructure = [];
    config.showComplianceStatusFilter = false;
    config.showCountryFilter = false;
    config.showRegulatoryAreaFilter = false;
    config.showPublicationTypeFilter = false;
    config.exportUrl = "/umbraco/api/Compliance/RegulatoryDocumentExport/?regDocsIds=";
    config.showTotalAndFilteredCounts = true;
    config.ComplianceType = "RegulatoryDocuments";
    config.enableTags = true;
    config.showLegalManufacturerFilter = true;
    config.currentLegalManufacturerFilter = window.legalManufacturerId;
    config.currentLegalManufacturerNameFilter = window.legalManufacturerName;
    config.showCMArchiveFilter = true;
    config.enableCustomFields = true;
    config.showRIMSFilter = true;
    config.enableMultiItemAIChatPane = true;
    config.showExportButton = true;
    config.enableTimelineGraph = true;
    config.preLoadItemUrlParamName = "viewItemId";
    config.excelExportFileName = "MedBoardComplianceExport";
    config.preLoadItemId = window.preloadRegulatoryDocumentId;
    config.reachedAllowance = window.reachedAllowanceRegulatoryDocuments;
    config.showTaskCount = true;

    useEffect(() => {

        loadStructure();

    }, []);


    const loadStructure = () => {

        setIsLoadingStructure(true);
        setErrorLoadingStructure(false);

        let tableHeaderUrl = "/umbraco/api/CustomFields/Headers/?entityType=" + config.entityTypeId;

        let requestOptions = {
            method: 'GET',
        };

        fetch(tableHeaderUrl, requestOptions)
            .then((response) => {
                
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                result.map(column => {
                    config.dataStructure.push({
                        customFieldId: column.CustomFieldId,
                        customFieldType: column.CustomFieldType,
                        name: column.Name,
                        field: column.Field,
                        width: column.Width,
                        sortable: column.Sortable,
                        isSelectItemCheckbox: column.IsSelectItemCheckbox,
                        renderWith: FieldTypes[column.RenderWith] ?? FieldTypes.FieldType_Text,
                        isMultiField: column.IsMultiField,
                        hasFilter: column.HasFilter
                        //hasFilter: true // FOR TESTING
                    });
                });

                setDataTableStructure(config);
                setIsLoadingStructure(false);
            })
            .catch((error) => {
                setErrorLoadingStructure(true);
            })
            .finally(() => {
            });
    }

    

    //dataTableStructure.dataStructure.push({ name: "", field: "Id", width: "25px", sortable: false, isSelectItemCheckbox: true });
    //dataTableStructure.dataStructure.push({ name: "Title", field: "Name", width: "25%", sortable: true, renderWith: FieldTypes.FieldType_Text });
    //dataTableStructure.dataStructure.push({ name: "Country", field: "Country", width: "10%", sortable: true, renderWith: FieldTypes.FieldType_Text });
    //dataTableStructure.dataStructure.push({ name: "Regulatory Area", field: "RegulatoryArea", width: "10%", sortable: true, renderWith: FieldTypes.FieldType_Text });
    //dataTableStructure.dataStructure.push({ name: "Type", field: "Type", width: "10%", sortable: true, renderWith: FieldTypes.FieldType_Text });
    //dataTableStructure.dataStructure.push({ name: "Pub. Date", field: "Date", width: "10%", sortable: true, renderWith: FieldTypes.FieldType_SimpleDate });
    //dataTableStructure.dataStructure.push({ name: "File", field: "MediaPath", width: "5%", sortable: true, renderWith: FieldTypes.FieldType_MediaPath, isMultiField: ["MediaPath", "MedboardResourceId"] });
    //dataTableStructure.dataStructure.push({ name: "Stage", field: "Stage", width: "10%", sortable: true, renderWith: FieldTypes.FieldType_Compliance_Stage });
    //dataTableStructure.dataStructure.push({ name: "Compliance Status", field: "Status", width: "10%", sortable: false, renderWith: FieldTypes.FieldType_Compliance_Status });
    //dataTableStructure.dataStructure.push({ name: "Legal Manufacturer", field: "LegalManufacturerId", width: "10%", sortable: false, renderWith: FieldTypes.FieldType_Compliance_LegalManufacturer });
    //dataTableStructure.dataStructure.push({ name: "Open Tasks", field: "TaskCount", width: "100px", sortable: true, renderWith: FieldTypes.FieldType_Open_Tasks });

    //dataTableStructure.dataUrlParameters = { search: null, page: 1, orderByField: "Name", orderByType: "ASCENDING", }

    return (<>

        {errorLoadingStructure ? <>
            <Error message={"Failed to load table configuration"} />
        </> : <>
                {isLoadingStructure ? <>
                    <LoadingSpinnerImage />
                </> : <>
                        <DataTable dataTableStructure={dataTableStructure} ItemDetailsPane={ItemDetailsPane} AddItemPopup={AddItemPopup} ReloadStructureFunction={loadStructure} />
                </>}

        </>}


    </>);

};






export default RegulatoryDocuments;